import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/feuilles-de-temps")({
  staticData: {
    permission: PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW,
  },
  loader: requirePermission(PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW),
  component: () => <Outlet />,
});
